import first from "lodash/first";
import get from "lodash/get";

const BundleInfo = ({ product, className }) => {
    const firstStore = first(get(product, 'store'));
    const piecesInBundle = firstStore?.piecesInBundle ?? 1;

    if (piecesInBundle > 1) {
        return (
            <>
                {piecesInBundle > 1 ? (
                    <small className={`text-nowrap ${className}`}>
                        {`bal. (${piecesInBundle ?? 1}${product?.measureUnit})`}
                    </small>
                ) : (
                    ""
                )}
            </>
        );
    }

    return null;
}

export default BundleInfo;
